module.exports = __webpack_public_path__ + "assets/keypad-sounds/beep6-aa2806ebce0b55b07fe3666e8c1014e5.wav";